{
  "sections_page": {
    "title": "Sections",
    "title_for_company": "{company} - Sections",
    "add_button": "Add section",
    "description": "Group a company's customers into a hierarchy of sections. Each section inherits the settings of the sections above it.",
    "description_company_sync": "Group a company's customers into a hierarchy of sections. Each section inherits the settings of the sections above it. Company sync is on, so new sections are created on your e-commerce platform.",
    "load_error": "We couldn't load this company's sections. Please try again.",
    "empty_state": {
      "title": "This company has no sections",
      "subtitle": "Add a section to start grouping this company's customers."
    }
  },
  "section_form_page": {
    "create_title": "Create section",
    "edit_title": "Edit {name}",
    "description": "Group customers within a company and override the settings they inherit.",
    "details": {
      "title": "Details",
      "name_label": "Section name",
      "name_placeholder": "e.g. North region",
      "external_id_label": "Platform ID",
      "external_id_placeholder": "Identifier on your e-commerce platform",
      "integration_id_label": "Integration ID",
      "integration_id_placeholder": "Identifier in another integration",
      "accounting_id_label": "Accounting ID",
      "accounting_id_placeholder": "Identifier in your accounting system"
    },
    "context": {
      "title": "Settings",
      "description": "Settings applied to customers belonging to this section."
    },
    "delete_confirm_title": "Delete section",
    "delete_confirm_body": "Are you sure you want to delete {name}? This can't be undone.",
    "company_sync_blocked": {
      "message": "Company sync is on, so sections can't be created here. Create the section on your e-commerce platform and it will sync across.",
      "back_button": "Back to sections"
    }
  }
}
